import { isAsset } from '../common/resource/model';

export const isFlex = (resource: any, versionId?: number | string): boolean => {
  if (resource) {
    if ('technology' in resource) {
      return resource.technology === 'flexGateway'
    } else if (isAsset(resource) && versionId) {
      let apis = resource.apis ? resource.apis.filter(api => `${api.id}` === `${versionId}`) : []
      if (apis && apis.length === 1) return isFlex(resource.apis[0])
    }
  }
  return false
}
